// The player label of a drilldown row: "F. Last". The label is the point name and the
// drilldown key, so it stays a plain string.
export function drilldownPlayerLabel(row) {
  return `${row?.player_id__first_name?.[0] ?? ""}. ${row?.player_id__last_name ?? ""}`;
}
